
import angular from 'angular';
import { AncillariesService } from '../../ib-web-ancillaries/ib-web-ancillaries-service';
import { DatalayerUtils } from 'src/app/shared/ib-datalayer-utils';
import { DatalayerConstantsType } from 'ib-web-commons/dist/app/core/ib-datalayer/ib-datalayer-constants';
import { IbInsuranceAllianzDatalayerUtilsService } from 'src/app/shared/ib-insurance-allianz-datalayer-utils.service';


const componentOptions = {
    bindings: {
        model: '=?',
        passengers: '='
    },
    controllerAs: 'insuranceCtrl',
    templateUrl: ['$rootScope', function ($rootScope) {
        return $rootScope.routes.templates + 'ib-insurance-allianz-fusion-view.html';
    }]
};


const componentInfo = {
    module: 'ib-insurance-allianz-fusion-module',
    selector: 'ibInsuranceAllianzFusion',
    inject: ['$scope', 'localStorageService', '$rootScope', '$timeout', 'AncillariesService', '$sce', 'AncillariesConstants', 'ModalServiceAncillaries', 'DatalayerUtils', 'DatalayerConstants', 'IbInsuranceAllianzDatalayerUtilsService'],
    required: ['']
};
export class ibInsuranceAllianzFusion implements angular.IController {
    public model;
    public output;
    public passengers;
    public passengerInfoTransformed;
    private flowApp = this.localStorageService.get('flowApp');
    constructor (private $scope: angular.IScope,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private $rootScope: CommonsRootScope,
        private $timeout: ng.ITimeoutService,
        private AncillariesService: AncillariesService,
        private $sce: any,
        private AncillariesConstants: AncillariesConstant,
        private ModalServiceAncillaries: any,
        private DatalayerUtils: DatalayerUtils,
        private DatalayerConstants: DatalayerConstantsType,
        private IbInsuranceAllianzDatalayerUtilsService: IbInsuranceAllianzDatalayerUtilsService) {

    }

    $onInit (): void {
        this.$timeout(() => {
            const ancillaries: any = this.localStorageService.get('ancillariesInfo');
            let insuranceInfo: any;
            const insurancesAvailable: any = [];
            angular.forEach(ancillaries.ancillaries, (anc) => {
                if (anc.type === 'ALLIANZ_FUSION') {
                    insuranceInfo = anc;
                }
            });
            angular.forEach(insuranceInfo.products, (ins) => {
                insurancesAvailable.push(ins);
            });
            insurancesAvailable.sort((a, b) => {
                return Number(a.totalPrice) - Number(b.totalPrice);
            });
            const withoutInsurance = insurancesAvailable[0];
            insurancesAvailable.shift();
            insurancesAvailable.push(withoutInsurance);
            this.formatCall(this.model, insurancesAvailable, insuranceInfo);
            this.DatalayerUtils.getAncillariesDigitalDataEcommerce('insurance', this.DatalayerConstants.EVENTS_ECOMMERCE.VIEW_ITEM_LIST);
        });
    }
    getPassengerInfoTransformed ()  {
        const {passengers} = this.model.passengersInfo.context;
        const passengersInfo = this.passengers;

        this.passengerInfoTransformed = passengers.filter(passengerFromContext => {
            return passengersInfo.some(passengerInfo => passengerFromContext.id === passengerInfo.id && passengerFromContext.passengerType === 'ADULT');
        }).map(item => ({...item, adult:true}));
        this.passengerInfoTransformed;
    }

    formatCall = (data:any, insurancesAvailable, insuranceInfo) => {
        this.output = this.$sce.trustAsHtml(data.output);
        this.initEventInAllianz(insurancesAvailable, insuranceInfo);
    };

    initEventInAllianz (insurancesAvailable, insuranceInfo) {
        this.$timeout(() => {
            angular.element('.ib-radio__input').on('change', (e) => {
                const insurancesOnTemplate:any = angular.element('ib-insurance-allianz-fusion').find('.ib-radio__input');
                let insuranceSelected: any;
                let insuranceNull: boolean = false;
                for (let i=0; i < insurancesOnTemplate.length; i++) {
                    if (insurancesOnTemplate[i] === e.currentTarget) {
                        insuranceSelected = insurancesAvailable[i];
                        if (i === insurancesOnTemplate.length - 1) {
                            insuranceNull = true;
                        }
                    }
                }

                if (insuranceNull) {
                    this.AncillariesService.deleteAllianzFusionInsurance().then(() => {
                        this.AncillariesService.deleteAllianzFusionInsuranceFromBasket();
                    }, angular.noop);
                } else {
                    const code = insuranceSelected.externalCode;
                    const price = insuranceSelected.totalPrice;
                    const description = insuranceSelected.productSpecificMessages[0].text;
                    let additionalInfoByPassenger;
                    const summaryInfo:any = (this.flowApp === 'MMB' || this.flowApp === 'MMBANC') ? this.localStorageService.get('breakdownInfo') : this.localStorageService.get('summaryInfo');
                    //this.getPassengerInfoTransformed();
                    //this.AncillariesService.addAllianzFusionInsuranceToBasket(this.AncillariesConstants.QUADRIGAM.ANCILLARIES_BKI.toLowerCase(), description, price);
                    const copyPassengerBaggagesTrips = this.localStorageService.get('passengerBaggagesTrips');
                    this.ModalServiceAncillaries.openInsuranceAllianzFusionModal({ passengersInfo: summaryInfo, insuranceRequirements: insuranceInfo.countriesRequiredInfo, passengers: this.passengers }, 'ib-modal-insurance-allianz-fusion.html').result.then(() => {
                        if (this.localStorageService.get('insuranceAllianzFusionPassengerInfo')) {
                            additionalInfoByPassenger = this.localStorageService.get('insuranceAllianzFusionPassengerInfo');
                            this.AncillariesService.updateAllianzFusionInsurance(code, additionalInfoByPassenger).then(() => {
                                this.AncillariesService.addAllianzFusionInsuranceToBasket(this.AncillariesConstants.QUADRIGAM.ANCILLARIES_BKI.toLowerCase(), description, price, code);
                                this.IbInsuranceAllianzDatalayerUtilsService.selectInsuranceEcommerceEventCart(insuranceSelected, 'select_item');
                                this.IbInsuranceAllianzDatalayerUtilsService.selectInsuranceEcommerceEventCart(insuranceSelected, 'add_to_cart');
                            }, angular.noop);
                        }else {
                            this.AncillariesService.deleteAllianzFusionInsuranceFromBasket();
                        }
                    });
                    this.localStorageService.remove('insuranceAllianzFusionPassengerInfo');
                }
            });
        }, 1000);
    }
}

try {
    const mod = angular.module(componentInfo.module);
    ibInsuranceAllianzFusion.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibInsuranceAllianzFusion })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibInsuranceAllianzFusion.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibInsuranceAllianzFusion })
    );
}